import type { SVGProps } from 'react'
const LineSwapHorizontal = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m17.03 3.47 3.895 3.895c.485.49.485 1.285 0 1.77L17.03 13.03l-1.06-1.06L18.94 9H10.5V7.5h8.44l-2.97-2.97zm-10.06 7.5 1.06 1.06L5.06 15h8.44v1.5H5.06l2.97 2.97-1.06 1.06-3.895-3.895a1.26 1.26 0 0 1 0-1.77z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineSwapHorizontal }
